<template>
  <div>
    <!-- BEGIN: Left Aside -->
    <button
      class="m-aside-left-close  m-aside-left-close--skin-dark "
      id="m_aside_left_close_btn"
      @click="toggleAsideMobileMenu"
    >
      <i class="flaticon-close"></i>
    </button>
    <div
      id="m_aside_left"
      class="m-grid__item m-aside-left m-aside-left--skin-dark "
    >
      <!-- BEGIN: Aside Menu -->
      <div
        id="m_ver_menu"
        class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark "
        m-menu-vertical="1"
        m-menu-scrollable="0"
        m-menu-dropdown-timeout="500"
      >
        <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
          <li class="m-menu__item">
            <router-link to="/dashboard" class="m-menu__link ">
              <span class="new-icons icon-home"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Dashboard</span>
                </span>
              </span>
              <div class="sidebar_popover">Dashboard</div>
            </router-link>
          </li>
          <li v-if="permissiom.brows_course != 0" class="m-menu__item">
            <router-link to="/browse_course" class="m-menu__link ">
              <span class="new-icons icon-browsing"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Browse Course</span>
                </span>
              </span>
              <div class="sidebar_popover">Browse Course</div>
            </router-link>
          </li>
          <li v-if="permissiom.dashboard_courses != 0" class="m-menu__item">
            <router-link to="/course" class="m-menu__link ">
              <span class="new-icons icon-open-book-1"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Courses</span>
                </span>
              </span>
              <div class="sidebar_popover">Courses</div>
            </router-link>
          </li>
          <li v-if="permissiom.dashboard_browse_exams != 0" class="m-menu__item">
            <router-link to="/exam" class="m-menu__link ">
              <span class="new-icons icon-browsing"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Browse Exams</span>
                </span>
              </span>
              <div class="sidebar_popover">Browse Exams</div>
            </router-link>
          </li>
          <li v-if="permissiom.my_payment != 0" class="m-menu__item">
            <router-link to="/my_payments" class="m-menu__link ">
              <span class="new-icons icon-coin-stack"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">My Payments</span>
                </span>
              </span>
              <div class="sidebar_popover">My Payments</div>
            </router-link>
          </li>
          <li v-if="permissiom.calendar != 0" class="m-menu__item">
            <router-link to="/calendar" class="m-menu__link ">
              <span class="new-icons icon-calendar"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Calendar</span>
                </span>
              </span>
              <div class="sidebar_popover">Calendar</div>
            </router-link>
          </li>
          <li v-if="permissiom.dashboard_classrooms != 0" class="m-menu__item">
            <router-link to="/classroom" class="m-menu__link">
              <span class="new-icons icon-presentation-1"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Classrooms</span>
                </span>
              </span>
              <div class="sidebar_popover">Classrooms</div>
            </router-link>
          </li>
          <li v-if="permissiom.chat_with_teacher != 0" class="m-menu__item">
            <router-link to="/chat_with_teacher" class="m-menu__link ">
              <span class="new-icons icon-chat"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Chat with Teacher</span>
                </span>
              </span>
              <div class="sidebar_popover">Chat with Teacher</div>
            </router-link>
          </li>
          <li class="m-menu__item">
            <a
              href="https://support.webcolms.com/415-2/"
              target="_blank"
              class="m-menu__link "
            >
              <span class="new-icons  flaticon-support"></span>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">Help</span>
                </span>
              </span>
              <div class="sidebar_popover">Help</div>
            </a>
          </li>
        </ul>
      </div>
      <!-- END: Aside Menu -->
    </div>
    <!-- END: Left Aside -->
  </div>
</template>

<script>
var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

export default {
  name: 'sidebar',

  data () {
    return {
      permissiom: []
    }
  },
  mounted () {
    this.permissiom = userPermissions
  },
  methods: {
    toggleAsideMobileMenu () {
      $('#m_aside_left_offcanvas_toggle').toggleClass(
        'm-brand__toggler--active'
      )
      $('#m_aside_left').toggleClass('m-aside-left--on')
      $('body').toggleClass('m-aside-left--on')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/component/sidebar/sidebar';
</style>
